import { render, staticRenderFns } from "./Agreement.vue?vue&type=template&id=2efa79b9&scoped=true&"
import script from "./Agreement.vue?vue&type=script&lang=ts&"
export * from "./Agreement.vue?vue&type=script&lang=ts&"
import style0 from "./Agreement.vue?vue&type=style&index=0&id=2efa79b9&prod&scoped=true&lang=css&"
import style1 from "./Agreement.vue?vue&type=style&index=1&id=2efa79b9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2efa79b9",
  null
  
)

export default component.exports